// File: src/components/Wrapper.js
import React from 'react';
import { Box, ThemeProvider } from '@mui/material';
import PropTypes from 'prop-types';
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    text: {
      primary: '#44546A',
    },
    primary: {
      main: '#44546A',
    },
    secondary: {
      main: '#33303C',
    },
  },
});
const Wrapper = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <Box
        id="layout-container"
        sx={{
          maxWidth: '430px', // Restrict max width to 430px
          margin: '0 auto', // Center the content horizontally
          width: '100%', // Take full width on smaller screens
          height: '100vh', // Optional: Full viewport height
          display: 'flex', // Optional: Flex for layout consistency
          flexDirection: 'column', // Optional: Column layout
          overflowX: 'hidden', // Prevent horizontal overflow
          bgcolor: '#F6F4F0', // Material-UI default background color
          color: 'text.primary', // Material-UI default text color
          background: '#F6F4F0',
        }}
      >
        {children}
      </Box>
    </ThemeProvider>
  );
};

Wrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Wrapper;
